import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=1ead4ae4&scoped=true"
import script from "./wishlist.vue?vue&type=script&lang=js"
export * from "./wishlist.vue?vue&type=script&lang=js"
import style0 from "./wishlist.vue?vue&type=style&index=0&id=1ead4ae4&prod&lang=scss&scoped=true"
import style1 from "./wishlist.vue?vue&type=style&index=1&id=1ead4ae4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead4ae4",
  null
  
)

export default component.exports